import React from 'react'
import PropTypes from 'prop-types'
import PaginationLink from 'component/pagination/Link'

const NewPagination = ({
  getPage,
  pages,
  current,
  count,
  component,
  navClass,
}) => {
  if (!count) {
    return false
  }

  let initialNumber = current < 5 ? 1 : current - 4
  const lastNumber = pages < 8 + initialNumber ? pages : 8 + initialNumber
  const diff = initialNumber - lastNumber + 8
  initialNumber -= initialNumber > diff ? diff : 0

  const paginationNumbers = []

  for (let i = initialNumber; i <= lastNumber; i++) {
    const linkProps = {
      getPage,
      key: i,
      pageNumber: i,
      active: i === current,
    }

    paginationNumbers.push(<PaginationLink {...linkProps} />)
  }

  const prevButtonProps = {
    getPage,
    className: 'prev-button',
    pageNumber: 1,
    glyphType: 'double-arrow-left',
    disabled: current === 1 || pages < 9,
  }

  const onePrevButtonProps = {
    getPage,
    className: `prev-button ${current === 1 ? 'disable-arrow' : ''}`,
    pageNumber: current - 5 < 1 ? 1 : initialNumber - 1 ,
    glyphType: 'one-arrow-left',
    disabled: pages <= 5 || current - 5 <= 0 ,
  }

  const onelastButtonProps = {
    getPage,
    className: 'next-button',
    pageNumber: lastNumber + 1 > pages ? lastNumber : lastNumber +1,
    glyphType: 'one-arrow-right',
    disabled: pages <= 9 || current + 9 > pages
  }

  const lastButtonProps = {
    getPage,
    className: 'next-button',
    pageNumber: pages,
    glyphType: 'double-arrow-right',
    disabled: current === pages || pages < 9
  }

  const className = `pagination margin-top margin-bottom ${navClass || ''}`

  return (
    <div className='row'>
      <div className='col-xs-12'>
        <nav className={className}>
          <PaginationLink {...prevButtonProps} />
          <PaginationLink {...onePrevButtonProps} />
          {paginationNumbers}
          <PaginationLink {...onelastButtonProps} />
          <PaginationLink {...lastButtonProps} />

          {component}
        </nav>
      </div>
    </div>
  )
}

NewPagination.propTypes = {
  getPage: PropTypes.func.isRequired,
  pages: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  component: PropTypes.any,
  navClass: PropTypes.string,
}

export default NewPagination
